import React from "react";

import dayjs from "dayjs";

import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowForward from "@mui/icons-material/ArrowForward";
import Avatar from "@mui/material/Avatar";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Grid from "@mui/material/Grid";
import ExpandCircleDownOutlinedIcon from "@mui/icons-material/ExpandCircleDownOutlined";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";

import DonationProductItem from "../../DonationProductItem";
import { CollectionStatus, ComponentType, EntityType } from "../../../../../common/enum";

import { useDispatch, useSelector } from "react-redux";

import {
  getMyCollection,
  resetCollection,
  updateCollection,
} from "../../../../CreateCollection/slice";
import { PRODUCT_ICON } from "../../../../../common/enum/productIcon";
import CollectionDonationProductCard from "../../../../../components/CollectionDonationCard/CollectionDonationProductCard";

function DonationProducts({
  donation,
  t,
  collectionById,
  collectionProduct,
  setCollection,
  setProductError,
  componentType,
}) {
  const [dateWithInitialValue, setDateWithInitialValue] = React.useState(null);
  const [currentError, setCurrentError] = React.useState(null);
  const [errorDate, setErrorDate] = React.useState(false);
  const dispatch = useDispatch();

  const {
    collection: { collectionId },
    auth: {
      profile: { entity },
      user: { userId },
    },
  } = useSelector((state) => state);

  const onSubmit = React.useCallback(
    (e) => {
      e.preventDefault();
      if (dateWithInitialValue !== null) {
        const payload = {
          collectionId: collectionId,
          status: CollectionStatus.reserved,
          dateOfCollection: dateWithInitialValue,
          updatedBy: entity?.entityId,
          addressId: "",
        };
        dispatch(updateCollection(payload))
          .unwrap()
          .then((response) => {
            dispatch(resetCollection());
            dispatch(
              getMyCollection({
                collectorId: userId,
                offset: 0,
                limit: 20,
                donorId: "",
                startDate: "",
                endDate: "",
                collectionId: 0,
              })
            );
          })
          .catch((error) => {
            alert("unable to update");
          });
      } else {
        setErrorDate(true);
        setCurrentError("Please select collection date");
      }
    },
    [dateWithInitialValue]
  );

  const products = React.useMemo(() => {
    if (donation) {
      return donation?.donationProducts?.filter(
        (item) => item.totalProductQuantity !== 0
      );
    }
    return [];
  }, [donation]);

  const groupDonationProduct = React.useMemo(() => {
    return products?.reduce((acc, pro) => {
      if (!acc[pro.productGroup]) {
        acc[pro.productGroup] = {};
        acc[pro.productGroup]["count"] = 0;
      }
      if (!acc[pro.productGroup][pro.productType]) {
        acc[pro.productGroup][pro.productType] = [];
      }
      acc[pro.productGroup]["count"] = acc[pro.productGroup]["count"] + 1;
      acc[pro.productGroup][pro.productType].push(pro);
      return acc;
    }, {});
  }, [products]);

  return (
    <>
      <Box sx={{ maxHeight: componentType === ComponentType.DONATION ? "100%" : "500px", overflow: "hidden", overflowY: "auto" }}>
        {groupDonationProduct !== undefined &&
          Object.keys(groupDonationProduct)?.map((item, index) => (
            <Accordion key={index}>
              <AccordionSummary
                expandIcon={<ExpandCircleDownOutlinedIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                sx={{
                  backgroundColor: "#e1efb0",
                  "& .MuiAccordionSummary-content": {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  },
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Avatar
                    alt={
                      PRODUCT_ICON.find(
                        (itemIcon) => itemIcon.productGroup === item
                      ).productGroup
                    }
                    src={
                      PRODUCT_ICON.find(
                        (itemIcon) => itemIcon.productGroup === item
                      ).url
                    }
                    sx={{
                      width: 24,
                      height: 24,
                      ml: 0.2,
                      mr: 1,
                    }}
                  />
                  <Typography variant="h6">{item}</Typography>
                </Box>
                <Box
                  sx={{
                    p: "2px 16px",
                    borderRadius: "40px",
                    backgroundColor: "primary.contrastText",
                    mr: 1,
                  }}
                >
                  <Typography variant="subtitle2" color={"primary"}>
                    {groupDonationProduct[item]["count"]}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                {Object.keys(groupDonationProduct[item]).map(
                  (itemType, index) => (
                    <React.Fragment key={index}>
                      {itemType !== "count" && (
                        <Typography
                          variant="body1"
                          color={"text.secondary"}
                          my={2}
                        >
                          {itemType === "undefined" ? "Product Type" : itemType}
                        </Typography>
                      )}
                      <Grid container spacing={1}>
                        {itemType !== "count" &&
                          groupDonationProduct[item][itemType].map((prod) => (
                            <Grid item xs={12} sm={12} key={prod.id}>
                              <CollectionDonationProductCard
                                t={t}
                                donationProduct={prod}
                                collectionProduct={collectionProduct}
                                setCollectionProduct={setCollection}
                                setProductError={setProductError}
                                componentType={componentType}
                              />
                            </Grid>
                          ))}
                      </Grid>
                    </React.Fragment>
                  )
                )}
              </AccordionDetails>
            </Accordion>
          ))}
      </Box>
      <br />
      {/* {(entity.enityType === EntityType.distributor ||
        entity.enityType === EntityType.donorDistributor) &&
        collectionId !== "" && (
          <Box component="form" onSubmit={onSubmit}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <MobileDateTimePicker
                value={dateWithInitialValue}
                onChange={(newValue) => {
                  setDateWithInitialValue(dayjs(newValue).toISOString());
                  setCurrentError(null);
                  setErrorDate(false);
                }}
                label={t("collectionDate")}
                onError={(reason, value) => {
                  if (reason) {
                    setCurrentError(reason);
                    setErrorDate(true);
                  } else {
                    setCurrentError(null);
                    setErrorDate(false);
                  }
                }}
                minDate={new Date()}
                inputFormat="YYYY/MM/DD hh:mm a"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    error={errorDate}
                    helperText={currentError ?? currentError}
                  />
                )}
              />
            </LocalizationProvider>
            <Button
              type={"submit"}
              size="small"
              variant="contained"
              sx={{ mt: 1 }}
              // onClick={() => {}}
            >
              <Typography variant="bold">Continuar</Typography>
              <ArrowForward fontSize="16px" />
            </Button>
          </Box>
        )} */}
    </>
  );
}

export default DonationProducts;
